import { useState, useEffect } from "react";
import {
  Box,
  TableContainer,
  Paper,
  Typography,
  TextField,
} from "@mui/material";
import styles from "../../../styles/gri/general.module.css";
import SectionHeading from "../GRI300/GRI308/SectionHeading";
function TableData({ inputData, columnWidth, title, setFromData,index,setErrors,errors,fromData, disabled}) {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (!inputData) return;

    const updatedData = inputData.map((table) => {
      const maxRows = Math.max(
        ...table.fields.map((field) => (field.item ? field.item.length : 0)),
        3
      );
        
      const columns = table.fields.length;
      const rows = Array.from({ length: maxRows }, (_, rowIndex) => ({
        fields: table.fields.map((field) => ({
          subheading: field.subheading,
          fieldName: field.fieldName,
          value: "",
          itemValue: field.item ? (field.item[rowIndex]?.value || field.item[rowIndex] || "") : "words", 
          placeholder: field?.placeholder,
          columns:columns
          // placeholder:
          // placeholder: field?.item[rowIndex]?.placeholder
          // key: field.item ? field.item[rowIndex]?.key || "" : "",
          // itemValue: field.item.map((item)=>item) , // Handling item values
        })),
        // {console.log()}
      }));
      console.log(maxRows,rows,columns,inputData.length,"maxRows")
      return rows;
    });
    setTableData(updatedData);
   
    // Dynamically set fromData based on inputData, specifically focusing on fields like `totalNonComplianceInstances`
    const updatedFromData = inputData.reduce((acc, table) => {
      table.fields.forEach((field) => {
        if (field.fieldName === "totalNonComplianceInstances" && field.item) {
          // For totalNonComplianceInstances category
          const itemRows = field.item.map((item, index) => ({
            category: item || "", // Assuming each item has category
            instances: "", // Add instances as necessary
          }));
          acc.totalNonComplianceInstances = itemRows;
        } else if (field.fieldName === "lawsAndRegulations" && field.item) {
          // Handle lawsAndRegulations field if it's present
          const itemRows = field.item.map((item, index) => ({
            category: item || "", // Handle category
            numberOfFines: "", // Initialize other necessary fields
            monetary: "", // Initialize other necessary fields
          }));
          acc.lawsAndRegulations = itemRows;
        } else if (field.fieldName === "significantNonComplianceInstances") {
          // Handle significantNonComplianceInstances
          acc.significantNonComplianceInstances = ""; // Assign the actual value
        } else if (field.fieldName === "nonComplianceSeverityAssessment") {
          // Handle nonComplianceSeverityAssessment
          acc.nonComplianceSeverityAssessment = ""; // Assign the actual value
        }
      });

      return acc;
    }, {});
  }, [inputData]);

  
  useEffect(()=>{
    
  },[fromData])
  console.log(tableData,"tableData")


  // const handleChange = (e,rowIndex) => {
  //   const { value, name } = e.target;
  //   console.log(value, name, "gyt");
  //   if (!/^\d*$/.test(value)) return;
  //   // Extract the main field and key
  //   const [main, key] = name.split(".");
  //   console.log(main,key,"value to chnage")
  //   setFromData((prevData) => ({
  //     ...prevData,
  //     [main]: {
  //       ...prevData[main],
  //       [key]: value, // Correctly updating the nested field
  //     },
  //   }));
  //   console.log(rowIndex,"rowIndexbb")
  // };
  
const handleChange = (e, rowIndex) => {
  const { value, name } = e.target;
  if (!/^\d*$/.test(value)) return;

  const [main, key] = name.split(".");

  setFromData((prevData) => {
    const updatedSection = {
      ...prevData[main],
      [key]: value,
    };

    const keys = Object.keys(updatedSection);
    const totalKey = keys.find((k) => k.toLowerCase().includes("total"));
    const otherKeys = keys.filter((k) => k !== totalKey);

    const isTotalField = key === totalKey;

    // Parse current values
    const currentVal1 = Number(key === otherKeys[0] ? value : prevData[main][otherKeys[0]] || 0);
    const currentVal2 = Number(key === otherKeys[1] ? value : prevData[main][otherKeys[1]] || 0);
    const total = Number(key === totalKey ? value : prevData[main][totalKey] || 0);

    const sum = currentVal1 + currentVal2;

    if (isTotalField) {
      // If total field is being edited, clear other two
      updatedSection[otherKeys[0]] = "";
      updatedSection[otherKeys[1]] = "";

      return {
        ...prevData,
        [main]: updatedSection,
      };
    } else {
      // User is editing one of the subfields — validate
      if (sum > total) {
        alert("Sum of fields cannot exceed total.");
        return prevData; // Block update
      }

      return {
        ...prevData,
        [main]: updatedSection,
      };
    }
  });
};






  return (
    <Box sx={{ minWidth: 650, marginTop: "30px" }}>
      {tableData.map((table, tableIndex) => (
        <>
        {/* <p
        className={styles.ques_heading}
        style={{ marginTop: "2.5rem", marginBottom: "0.5rem",display: "flex" }}
      >
       <p style={{marginRight:"0.3rem",marginBottom: "0rem"}}>{inputData[tableIndex]?.index}</p> 
       {inputData[tableIndex]?.title}
      </p> */}
      <SectionHeading marginBottom="0px"
      text={`${inputData[tableIndex]?.index}  ${inputData[tableIndex]?.title}`}
      />
        <TableContainer
          key={tableIndex}
          component={Paper}
          sx={{ maxWidth: "95%", marginBottom: "20px",borderRadius:"10px",marginLeft:"15px" }}
        >
          <Box>
            {/* Render Headers */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns:
                  tableIndex === 1 ? "10% 38% 21% 31%" : columnWidth,
                background: "#1C486B",
                borderBottom: "1px solid #ddd",
                borderTop: "1px solid #ddd",
              }}
            >
              {inputData[tableIndex].fields.map((field, index) => (
                <Typography
                  key={index}
                  sx={{
                    height: "100%",
                    padding: "8px 12px",
                    color: "#FFFFFF",
                    paddingY: "10px",
                    borderRight: "1px solid #DBDBDB",
                    display: "flex",
                    justifyContent:  index==0?"center":"left",
                    alignItems: index==0?"center":"left", 
                  }}
                >
                  {field.subheading}
                </Typography>
              ))}
            </Box>

            {/* Render Data Rows */}
            {table.map((row, rowIndex) => (
              <Box
                key={rowIndex}
                sx={{
                  display: "grid",
                  gridTemplateColumns:
                    row.fields.length === 3 ? columnWidth : "10% 38% 21% 31%",
                  borderBottom: "1px solid #ddd",
                  justifyContent: "center",
                }}
              >
                {row.fields.map((field, fieldIndex) => (
                
                  <Box sx={{
                    borderRight: "1px solid #DBDBDB",
                    fontSize: "15px",
                    padding: "5px 1px",
                    display: "flex",
                    flexDirection: "column",
                    // justifyContent: "center",
                    // alignItems: "center",
                  }}>
                  
                  
                 
                    <Box  >
                     
                    <p style={{color:fieldIndex==1&&"#1C486B",textAlign:fieldIndex==0?"center":"left",
                      paddingTop:(fieldIndex==1||fieldIndex==0)?"0.8rem":"0"
                     }}>
       {field?.itemValue==="words"?
                            <TextField
                              // key={index} // Adding a key for mapping
                              variant="standard"
                              sx={{
                                backgroundColor:
                                  // isPercentage || isTotal || isTotalRow
                                  //   ? "#EFEFEF"
                                    // :
                                     "",
                                // borderRight: "1px solid #DBDBDB",
                                padding: "8px 12px",
                                "& .MuiInputBase-root": {
                                  padding: 0, // Align with grid cells
                                },
                              }}
                               name={`${field?.fieldName}.${inputData[tableIndex]?.fields[1]?.item[rowIndex]?.key}` }
                              type="text"
                              InputProps={{ disableUnderline: true }}
                              fullWidth
                              size="small"
                              // value={
                                
                              // }
                              value={fromData?.[field?.fieldName]?.[inputData[tableIndex]?.fields[1]?.item[rowIndex]?.key] || ""}
                              placeholder={
                                // isTotal
                                //   ? "Total"
                                //   : isPercentage
                                //   ? "%"
                                  // :
                                  field?.placeholder?  field?.placeholder:
                                 "Enter Number"
                              }
                              onChange={
                                
                                   (e) => handleChange(e, rowIndex)
                                 
                              }
                              disabled={disabled}
                            />
                          :
                          field?.itemValue} 
    </p>
    
   
                  </Box> 
                  
                   </Box>
                  
                ))}
              </Box>
            ))}
          </Box>
        </TableContainer>
        </>
      ))}
    </Box>
  );
}

export default TableData;
